export interface NO05SearchParams {
  companyId: string;
  status?: string;
  orderNumber?: string;
  customerNumber?: string;
  requisitionNumber?: string;
  productId?: string;
  invoiceCreditNumber?: string;
  receiver?: string;
  location?: string;
  address?: string;
  department?: string;
  warehouse?: string;
  fromDate?: string;
  toDate?: string;
  page?: number;
  pageSize?: number;
  skipPaging?: boolean;
}

export interface NO05StatusStat {
  status: string;
  count: number;
  totalAmount: number;
  brfProsent: number;
  /** Dekningsgrunnlag in kroner, summed over the orders in this group — see NO05Order.brfOmsetning. */
  brfOmsetning: number;
  /** Cost of goods in kroner, summed over the orders in this group. */
  brfKost: number;
  antBestilt: number;
  antLevert: number;
}

export interface NO05Order {
  ordreNr: string;
  kundenr: string;
  navn: string;
  rekvNr: string;
  dato: string;
  tid: string;
  om: string;
  status: string;
  antBestilt: number;
  antLevert: number;
  belop: number;
  brfProsent: number;
  /**
   * Dekningsgrunnlag in kroner for THIS order's own BRF% (brfProsent above) — NOT the same
   * as `belop`: surcharge (Tillegg, any type) and Frakt (the freight line) count towards the
   * order amount but never towards this (decided 2026-09-21). Sum this and brfKost across
   * orders to get a combined BRF% — averaging brfProsent, even weighted by belop, gives a
   * different (wrong) number.
   */
  brfOmsetning: number;
  /** Cost of goods in kroner, for the same lines as brfOmsetning. */
  brfKost: number;
  faktura: string;
  fraktEdi: string;
  ordreType: string;
  betalingsKode: string;
  sendeMote: string;
  speditor: string;
  direkteFlagg: string;
  skaff: string;
  bk: string;
  /** O-RECTYPE — with ordreNr, identifies the order (order numbers are recycled across years). */
  recordType: string;
}

export default class NO05 implements NO05Order {
  ordreNr: string;
  kundenr: string;
  navn: string;
  rekvNr: string;
  dato: string;
  tid: string;
  om: string;
  status: string;
  antBestilt: number;
  antLevert: number;
  belop: number;
  brfProsent: number;
  brfOmsetning: number;
  brfKost: number;
  faktura: string;
  fraktEdi: string;
  ordreType: string;
  betalingsKode: string;
  sendeMote: string;
  speditor: string;
  direkteFlagg: string;
  skaff: string;
  bk: string;
  recordType: string;

  constructor(
    ordreNr = '', kundenr = '', navn = '', rekvNr = '',
    dato = '', tid = '', om = '', status = '',
    antBestilt = 0, antLevert = 0, belop = 0, brfProsent = 0,
    brfOmsetning = 0, brfKost = 0,
    faktura = '', fraktEdi = '', ordreType = '', betalingsKode = '', sendeMote = '',
    speditor = '', direkteFlagg = '', skaff = '', bk = '', recordType = '',
  ) {
    this.ordreNr = ordreNr; this.kundenr = kundenr; this.navn = navn;
    this.rekvNr = rekvNr; this.dato = dato; this.tid = tid; this.om = om;
    this.status = status; this.antBestilt = antBestilt; this.antLevert = antLevert;
    this.belop = belop; this.brfProsent = brfProsent;
    this.brfOmsetning = brfOmsetning;
    this.brfKost = brfKost; this.faktura = faktura;
    this.fraktEdi = fraktEdi; this.ordreType = ordreType;
    this.betalingsKode = betalingsKode; this.sendeMote = sendeMote;
    this.speditor = speditor; this.direkteFlagg = direkteFlagg;
    this.skaff = skaff; this.bk = bk; this.recordType = recordType;
  }
}
